import * as React from "react";
import { makeStyles } from "@mui/styles";
import { markOrderAsArtworkChangeRequestedMutation } from "../../graph";
import { useMutation } from "@apollo/client";
import { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import PendingStatusView from "../PendingStatusView";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import withSnackbar from "../withSnackbar";

const useStyles = makeStyles(theme => ({
  content: {
    paddingTop: theme.spacing(2)
  }
}));

const RequestArtworkChangeModal = ({
  isOpen,
  onRequestClose,
  orderId,
  showErrorSnackbar
}) => {
  const classes = useStyles();

  // States:
  const [isRequestingArtworkChange, setIsRequestingArtworkChange] =
    useState(false);
  const [mutationErrors, setMutationErrors] = useState({
    description: [],
    orderId: []
  });
  const [notesInputValue, setNotesInputValue] = useState("");
  const { description: descriptionErrors, orderId: orderIdErrors } =
    mutationErrors;

  // Mutations
  const [markOrderAsArtworkChangeRequested] = useMutation(
    markOrderAsArtworkChangeRequestedMutation
  );

  // Handlers:
  const handleNotesInputChange = event =>
    setNotesInputValue(event.target.value);

  const handleCancelButtonClick = () => onRequestClose();

  const handleSubmitButtonClick = () => {
    const description = notesInputValue;

    setIsRequestingArtworkChange(true);
    markOrderAsArtworkChangeRequested({
      variables: { description, orderId }
    })
      .then(
        ({
          data: {
            markOrderAsArtworkChangeRequested: { errors, succeeded }
          }
        }) => {
          if (succeeded) {
            onRequestClose();
          } else {
            setMutationErrors(errors);
          }
        }
      )
      .catch(e => {
        showErrorSnackbar(e.message);
      })
      .finally(() => setIsRequestingArtworkChange(false));
  };

  return (
    <Dialog
      aria-describedby="Request Artwork Change"
      aria-labelledby="RequestArtworkChangeModal"
      open={isOpen}
      onClose={onRequestClose}
      fullWidth={true}
    >
      <DialogTitle>Request Artwork Change</DialogTitle>
      <DialogContent className={classes.content}>
        {isRequestingArtworkChange ? (
          <PendingStatusView status="Loading" />
        ) : (
          <>
            <TextField
              id="outlined-simple-start-adornment"
              variant="outlined"
              multiline={true}
              error={descriptionErrors && descriptionErrors.length > 0}
              helperText={
                descriptionErrors &&
                descriptionErrors.length > 0 &&
                descriptionErrors.join(", ")
              }
              label="Description"
              onChange={handleNotesInputChange}
              value={notesInputValue}
              fullWidth={true}
              rows={5}
            />
            {orderIdErrors.length > 0 && (
              <Typography color="error">{orderIdErrors.join(", ")}</Typography>
            )}
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancelButtonClick} color="primary">
          Cancel
        </Button>
        <Button onClick={handleSubmitButtonClick} color="primary">
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default withSnackbar(RequestArtworkChangeModal);
